import Vue from 'vue'
import VueRouter from 'vue-router'

import App from './App.vue'
import VueClipboard from 'vue-clipboard2'
import Toasted from 'vue-toasted';
import SsoAccess from './components/SsoAccess.vue'
import Installers from './components/Installers.vue'
import Documentation from './components/Documentation.vue'

Vue.config.productionTip = false
VueClipboard.config.autoSetContainer = true 
Vue.use(VueClipboard)
Vue.use(VueRouter)

const toastOptions = {
  duration: 4000,
  position: 'top-center'
}

Vue.use(Toasted, toastOptions)
 
const routes = [
  { path: '/sso-access', name:'sso', component: SsoAccess },
  { path: '/installers', name:'installers', component: Installers }, 
  { path: '/docs', name:'docs', component: Documentation }  
]

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  const queryParams = new URLSearchParams(window.location.search.substring(1)) 
  if (to.path === "/" && queryParams && queryParams.get("code")) {
    next({
      name: 'sso',
      query: { code: queryParams.get("code") }
    })
  } else {
    next()
  }
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')


